var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.875H3.79167C3.28334 2.875 2.79582 3.07693 2.43638 3.43638C2.07693 3.79582 1.875 4.28334 1.875 4.79167V18.2083C1.875 18.7167 2.07693 19.2042 2.43638 19.5636C2.79582 19.9231 3.28334 20.125 3.79167 20.125H17.2083C17.7167 20.125 18.2042 19.9231 18.5636 19.5636C18.9231 19.2042 19.125 18.7167 19.125 18.2083V11.5",
    stroke: "#FBFBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6094 2.5156C16.9906 2.13435 17.5077 1.92017 18.0469 1.92017C18.586 1.92017 19.1031 2.13435 19.4844 2.5156C19.8656 2.89685 20.0798 3.41393 20.0798 3.9531C20.0798 4.49227 19.8656 5.00935 19.4844 5.3906L10.5 14.375L6.66667 15.3333L7.62501 11.5L16.6094 2.5156Z",
    stroke: "#FBFBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.83e3934f0bdf3b1f593d5b58e3704509.svg";
export { ForwardRef as ReactComponent };